module.exports = __webpack_public_path__ + "static/media/instagram.1e1b8848.svg";